angular.module('contactModule').component('contactPredev', {
	templateUrl: 'contactPredev/contactPredev.html',
	bindings: {
		page: '<',
		target: '<',
		user: '<',
		startingDate: '<',
		nbDays: '<',
		type: '<',
		multisteps: '<',
		companyPhone: '<',
		photoPlaceholder: '<',
		errorMessages: '<',
		successMessage: '<',
		tabindexOrder: '<',
		subTitle: '<',
		isMobile: '<',
		contactId: '<',
		onSubmitForm: '&',
		emptyMessage: '<',
		emptyBuyerRenter: '<'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', 'crResourcesService', function($timeout, $window, PubSub, $element, crResourcesService) {
		var ctrl = this;

		this.$onInit = () => {
		};


		this.submit = () => {
			this.form.showMessage = false;
			this.onSubmitForm({form: this.form});
		};


	}]
});